import { useEffect, useState } from 'react';
import Location from '../../../hooks/Location';
import { useFirestoreID, useFirestoreQuery } from '../../../firebase/useFirestore';
import parseTimestampParam from '../../../helpers/questionnaire/parseTimestampParam';
import ResearchResultsPageHeader from '../../measurementPlan/ResearchResultsPageHeader.jsx';
import ResearchResultsQuestionList from '../../measurementPlan/ResearchResultsQuestionList.jsx';

/**
 * Eén ingevuld formulier van één deelnemer (persona).
 *
 * Zelfde weergave als "Onderzoeksresultaten · Formulier": dezelfde kaarten per
 * vraagtype, dezelfde kop, dezelfde effecttitel boven meetstandaardvragen. Het
 * enige verschil is dat de antwoorden hier bij één persona horen — de inzending
 * wordt vastgezet op `Persona` + `Timestamp` in plaats van op een `FormID`.
 */
const ResearchResultsPersonasForms = () => {
    // State
    const [researchTitle, setResearchTitle] = useState('');
    const [personaTitle, setPersonaTitle] = useState('');
    const [questionnaireId, setQuestionnaireId] = useState('');

    // Hooks
    const personaId = Location()[3];
    const researchId = Location()[4];
    const timestampParam = Location()[5];

    // De tijdstempel staat als "seconden-nanoseconden" in de URL; '' betekent
    // "nog geen waarde", zodat de query wordt overgeslagen in plaats van leeg
    // terug te komen.
    // AI-CONTEXT: See docs/pitfalls.md#database-firestore-null-is-a-valid-query-value
    const timestamp = parseTimestampParam(timestampParam) || '';
    const match = [['Persona', personaId || ''], ['Timestamp', timestamp]];

    // Firestore
    const research = useFirestoreID('Research', researchId ? researchId : '');
    const personas = useFirestoreID('Personas', personaId ? personaId : '');
    // Alle antwoorden van deze inzending — voedt datum, meetmoment en telling in de kop.
    const formResponses = useFirestoreQuery('QuestionnairesResponses', {
        where: [
            ['ResearchID', '==', researchId || ''],
            ...match.map(([key, value]) => [key, '==', value]),
        ],
    });

    // Zet de onderzoekstitel + de vragenlijst.
    useEffect(() => {
        research && research.forEach((item) => {
            setResearchTitle(item.Title);
            setQuestionnaireId(item.QuestionnaireID);
        });
    }, [research]);

    // Zet de naam van de deelnemer.
    useEffect(() => {
        personas && personas.forEach((item) => {
            setPersonaTitle(item.Name);
        });
    }, [personas]);

    return (
        <div className="main">
            <div className="main-container">
                <ResearchResultsPageHeader
                    heading={researchTitle}
                    subHeading={personaTitle}
                    responses={formResponses}
                />
                <ResearchResultsQuestionList
                    questionnaireId={questionnaireId}
                    researchId={researchId}
                    match={match}
                />
            </div>
        </div>
    );
};

export default ResearchResultsPersonasForms;
